// components/InstallModal.jsx   ← 完全跟你最新截图一模一样的版本
export default function InstallModal({ isOpen, onClose, onConfirmInstall }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-end justify-center"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-t-3xl w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        {/* 小灰条（保留，和真实手机一模一样） */}
        <div className="flex justify-center pt-3">
          <div className="w-12 h-1 bg-gray-400 rounded-full opacity-60" />
        </div>

        <div className="px-5 pt-4 pb-8">

          {/* App 图标 + 名称 + 域名 + 安装按钮 */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-4">
              <img
                src="/assets/cash-jackpot.webp"
                alt="Jackpot Reels"
                className="w-14 h-14 rounded-xl shadow-sm"
              />
              <div>
                <p className="font-semibold text-gray-900 text-lg">Jackpot Reels</p>
                <p className="text-xs text-gray-500">winwinwink.com</p>
              </div>
            </div>
            <button
              onClick={onConfirmInstall}
              className="bg-blue-600 text-white px-8 py-3 rounded-full font-medium shadow-md text-base"
            >
              Install
            </button>
          </div>

          {/* 关键：灰色分隔线 */}
          <div className="h-px bg-gray-300 my-5" />

          {/* 描述文字 */}
          <p className="text-sm text-gray-700 leading-relaxed mb-6">
            Endless excitement in your hand! Explore thrilling online slot machines.
          </p>

          {/* 三张横向滑动截图 */}
          <div className="flex gap-4 overflow-x-auto pb-2 -mx-5 px-5">
            <img
              src="/image/default/1.jpg"
              className="w-36 h-64 object-cover rounded-lg flex-shrink-0 shadow-md"
              alt=""
            />
            <img
              src="/image/default/2.jpg"
              className="w-36 h-64 object-cover rounded-lg flex-shrink-0 shadow-md"
              alt=""
            />
            <img
              src="/image/default/3.jpg"
              className="w-36 h-64 object-cover rounded-lg flex-shrink-0 shadow-md"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}